/**
 * Where a Start Guide step gets its completed / locked state.
 *
 * "client" — derive it in the browser until the setup-guide API exists.
 * "server" — use the payload stored with setServerStartGuideStatus().
 *
 * Server payload for one project:
 * {
 *   steps: {
 *     business: { complete: true },
 *     registration: { complete: false, locked: true, lockReason: "..." }
 *   }
 * }
 */
export const START_GUIDE_STATUS_SOURCE = "server";

/**
 * Review switch. Kept off: step completion comes from GET /user/start_guide,
 * not from a wiped local checklist.
 */
export const START_GUIDE_FRESH_VISIT = false;

export const isServerStartGuideStatus = () =>
  START_GUIDE_STATUS_SOURCE === "server";
